/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AccountDeletionDtoFromJSON, BountyResponseDtoFromJSON, MeResponseFromJSON, NotificationFeedResponseFromJSON, NotificationPreferencesDtoFromJSON, OperationToJSON, OwnerBountyResponseDtoPageResponseFromJSON, PushConfigResponseFromJSON, RejectBountyResponseRequestToJSON, RemovePushSubscriptionRequestToJSON, SavePushSubscriptionRequestToJSON, SubmitBountyRequestToJSON, SubmitBountyResponseFromJSON, SubmitBountyResponsePageResponseFromJSON, UpdateNotificationPreferencesRequestToJSON, UserPreferencesDtoFromJSON, UserPreferencesDtoToJSON, UserProfileDetailsDtoFromJSON, UserProfileDetailsDtoToJSON, UserProfileDtoFromJSON, UserWalletDtoFromJSON, } from '../models/index';
/**
 *
 */
export class MeApi extends runtime.BaseAPI {
    /**
     */
    meAcceptBountyResponseByBountyIdAndResponseIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.bountyId === null || requestParameters.bountyId === undefined) {
                throw new runtime.RequiredError('bountyId', 'Required parameter requestParameters.bountyId was null or undefined when calling meAcceptBountyResponseByBountyIdAndResponseId.');
            }
            if (requestParameters.responseId === null || requestParameters.responseId === undefined) {
                throw new runtime.RequiredError('responseId', 'Required parameter requestParameters.responseId was null or undefined when calling meAcceptBountyResponseByBountyIdAndResponseId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/bounties/{bountyId}/responses/{responseId}/accept`.replace(`{${"bountyId"}}`, encodeURIComponent(String(requestParameters.bountyId))).replace(`{${"responseId"}}`, encodeURIComponent(String(requestParameters.responseId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => BountyResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meAcceptBountyResponseByBountyIdAndResponseId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meAcceptBountyResponseByBountyIdAndResponseIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meCancelAccountDeletionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/account-deletion`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    meCancelAccountDeletion(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.meCancelAccountDeletionRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    meCreateUserProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/profile`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UserProfileDetailsDtoToJSON(requestParameters.userProfileDetailsDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserProfileDetailsDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meCreateUserProfile(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meCreateUserProfileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meFetchMeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MeResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    meFetchMe(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meFetchMeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meGetNotificationPreferencesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/notification-preferences`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => NotificationPreferencesDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meGetNotificationPreferences(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meGetNotificationPreferencesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meGetNotificationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.since !== undefined) {
                queryParameters['since'] = requestParameters.since.toISOString();
            }
            if (requestParameters.before !== undefined) {
                queryParameters['before'] = requestParameters.before.toISOString();
            }
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/notifications`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFeedResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    meGetNotifications(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meGetNotificationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meGetPushConfigRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/push/config`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PushConfigResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    meGetPushConfig(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meGetPushConfigRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meGetUserWalletRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/wallet`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserWalletDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meGetUserWallet(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meGetUserWalletRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meMarkAllNotificationsReadRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/notifications/read-all`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    meMarkAllNotificationsRead(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.meMarkAllNotificationsReadRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    meMarkNotificationReadByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling meMarkNotificationReadById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/notifications/{id}/read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    meMarkNotificationReadById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.meMarkNotificationReadByIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    mePaginateBountyResponsesByBountyIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.bountyId === null || requestParameters.bountyId === undefined) {
                throw new runtime.RequiredError('bountyId', 'Required parameter requestParameters.bountyId was null or undefined when calling mePaginateBountyResponsesByBountyId.');
            }
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/bounties/{bountyId}/responses`.replace(`{${"bountyId"}}`, encodeURIComponent(String(requestParameters.bountyId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OwnerBountyResponseDtoPageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mePaginateBountyResponsesByBountyId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mePaginateBountyResponsesByBountyIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    mePaginateUserBountiesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/bounties`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SubmitBountyResponsePageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    mePaginateUserBounties(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.mePaginateUserBountiesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meRejectBountyResponseByBountyIdAndResponseIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.bountyId === null || requestParameters.bountyId === undefined) {
                throw new runtime.RequiredError('bountyId', 'Required parameter requestParameters.bountyId was null or undefined when calling meRejectBountyResponseByBountyIdAndResponseId.');
            }
            if (requestParameters.responseId === null || requestParameters.responseId === undefined) {
                throw new runtime.RequiredError('responseId', 'Required parameter requestParameters.responseId was null or undefined when calling meRejectBountyResponseByBountyIdAndResponseId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/bounties/{bountyId}/responses/{responseId}/reject`.replace(`{${"bountyId"}}`, encodeURIComponent(String(requestParameters.bountyId))).replace(`{${"responseId"}}`, encodeURIComponent(String(requestParameters.responseId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RejectBountyResponseRequestToJSON(requestParameters.rejectBountyResponseRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => BountyResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meRejectBountyResponseByBountyIdAndResponseId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meRejectBountyResponseByBountyIdAndResponseIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meRemovePushSubscriptionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/push-subscriptions/remove`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RemovePushSubscriptionRequestToJSON(requestParameters.removePushSubscriptionRequest),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    meRemovePushSubscription(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.meRemovePushSubscriptionRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    meRequestAccountDeletionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/profile`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AccountDeletionDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meRequestAccountDeletion(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meRequestAccountDeletionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meSavePushSubscriptionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/push-subscriptions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SavePushSubscriptionRequestToJSON(requestParameters.savePushSubscriptionRequest),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    meSavePushSubscription(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.meSavePushSubscriptionRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    meSetNotificationPreferencesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/notification-preferences`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateNotificationPreferencesRequestToJSON(requestParameters.updateNotificationPreferencesRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => NotificationPreferencesDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meSetNotificationPreferences(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meSetNotificationPreferencesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meSetUserPreferencesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/preferences`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UserPreferencesDtoToJSON(requestParameters.userPreferencesDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserPreferencesDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meSetUserPreferences(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meSetUserPreferencesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meSubmitBountyRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/bounties`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SubmitBountyRequestToJSON(requestParameters.submitBountyRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SubmitBountyResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    meSubmitBounty(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meSubmitBountyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    meUpdateUserProfileDetailsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/me/profile`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.operation.map(OperationToJSON),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserProfileDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    meUpdateUserProfileDetails(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.meUpdateUserProfileDetailsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
